<template>
  <div>
    <HeaderComponent/>

    <About/>

    <HowItWorks/>

    <MainForm/>


    <BannerPeople/>

    <Faq/>

    <Contacts/>

    <div class="container">
      <div class="parting d-flex flex-column">
        <div class="text-center d-block parting__title text-medium">До зустрічі на Нова пошта Гранд Пікнік!
        </div>
        <div class="parting__sticker position-relative text-center d-inline-b">
          Чекаємо на тебе!<span class="parting__sticker-icon position-absolute d-block">😜</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue';
import MainForm from '@/components/MainForm';
import BannerPeople from '@/components/BannerPeople';
import About from '@/components/About';
import HowItWorks from '@/components/HowItWorks';
import Contacts from '@/components/Сontacts';
import Faq from '@/components/Faq';

export default {
  name: 'Home',
  components: {
    HeaderComponent,
    MainForm,
    BannerPeople,
    About,
    HowItWorks,
    Contacts,
    Faq,
  },
};
</script>
<style scoped lang="scss">
@use 'sass:math';
@import '../assets/styles/parts/variables';
@import '../assets/styles/parts/mixins';
.parting{
  padding-top: sm(144);
  padding-bottom: sm(127);
  @include _1024 {
    padding-top: sl(240);
    padding-bottom: sl(32);
  }
  @include _1920 {
    padding-top: 240px;
    padding-bottom: 32px;
  }
  &__title {
    font-size: sm(24);
    padding-bottom: sm(40);
    line-height: math.div(83.2 , 64);
    @include _1024 {
      font-size: sl(64);
      padding-bottom: sl(50);
    }
    @include _1920 {
      font-size: 64px;
      padding-bottom: 50px;
    }
  }
  &__sticker {
    background: $white;
    box-shadow: 0px 6px 12px rgba(84, 101, 101, 0.12);
    border-radius: sm(8);
    transform: rotate(5deg);
    font-size: sm(16);
    padding: sm(13.95) sm(16.99);
    margin: 0 auto;
    line-height: math.div(36, 24);
    @include _1024 {
      border-radius: sl(8);
      margin-right: sl(102);
      font-size: sl(24);
      padding: sl(13.95) sl(16.99);
    }
    @include _1920 {
      border-radius: 8px;
      font-size: 24px;
      padding: 13.95px 16.99px;
      margin-right: 102px;
    }
    &-icon {
      font-size: sm(32);
      text-shadow: 3px 4px 10px rgba(84, 101, 102, 0.25);
      transform: rotate(-10deg);
      width: sm(32);
      height: sm(48);
      left: sm(-21);
      top: sm(-20);
      @include _1024 {
        width: sl(48);
        height: sl(72);
        font-size: sl(48);
        top: sl(-40);
        left: sl(-40);
      }
      @include _1920 {
        width: 48px;
        height: 72px;
        font-size: 48px;
      }
    }
  }
}

</style>
